import { Button, Dropdown } from '@ibsys/kit';
import { ChevronDownIcon, PaperclipIcon } from 'lucide-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useThemeConfig } from '@/entities/settings';
import type { BrokenContentImage } from '../model/htmlContent';
import { getBrokenImageMenuItems } from './brokenImageMenuItems';

type Props = {
  /** Крупные и безразмерные не загрузившиеся картинки облака */
  images: BrokenContentImage[];
};

/**
 * Крупные не загрузившиеся картинки — группой «N вложений» с фавиконом проекта в конце облака;
 * пункт группы открывает картинку в новой вкладке.
 */
export const LargeAttachmentsGroup: FC<Props> = ({ images }) => {
  const { t } = useTranslation(['dialogs']);
  const { data: projectConfig } = useThemeConfig();
  const favicon = projectConfig?.favicon;

  const options = getBrokenImageMenuItems(images, PaperclipIcon);

  return (
    <Dropdown options={options}>
      <Button
        variant="outline"
        size="sm"
        className="max-w-full self-start not-italic"
        icon={favicon ? <img src={favicon} alt="" className="size-4" /> : <PaperclipIcon className="size-4" />}
      >
        {t('dialogs:textFeed.attachmentsCount', { count: images.length })}
        <ChevronDownIcon className="size-3.5" />
      </Button>
    </Dropdown>
  );
};
